import axios from "axios";

export const loginApi = async (key, password, url) => {
  try {
    console.log(process.env)
    const res = await axios.post(`${url}/device/authDeviceWeb`, {
      key,
      password
    })
    return res.data;
  } catch (error) {
    console.log(error);
  }
}

export const getDeviceApi = async (url,playlistId) => {
  const res = await axios.get(`${url}`, {params:{ playlistId}})
  return res?.data;
}
export const getDeviceWithCodeApi = async (code) => {
  const res = await axios.post(`https://backend.konekt.vip/device/getDeviceForWebPlayerWithAndroidCode`, {deviceCode: code});
  return res?.data;
}
export const getContentByMac = async (mac) => {
  const res = await axios.post(`https://backend.konekt.vip/androidKeys/getmaccontent`, {mac});
  return res?.data;
}

export const getDeviceAllDisplaysApi = async (token, url) => {
  try {
    const res = await axios.get(`${url}/device/getDeviceAllDisplays`, {
      headers:{
        token: `bearer ${token}`
      }
    })
    return res?.data;
  } catch (error) {
    console.log(error);
  }  
}

export const switchDeviceDisplayApi = async (token, url, displayName) => {
  try {
    const res = await axios.get(
      `${url}/device/setDisplayByDevice?displayName=${displayName}`,
      {
        headers:{
          token: `bearer ${token}`
        } 
      }
    );
    console.log(res)
  } catch (error) {
    console.log(error);
  }
}